export default "__VITE_ASSET__DoEE5YyJ__"